import React, { useState } from 'react';

import PropTypes from 'prop-types';

import {
  invalidateSuggestions,
  loadSuggestions,
} from 'common/actions/azureDevopsWorkItemSuggestions';
import { reloadPost } from 'common/actions/posts';
import AJAX from 'common/AJAX';
import connect from 'common/core/connect';
import AdminIntegrationSearchForm from 'common/subdomain/admin/AdminIntegrationSearchForm';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';
import styles from 'css-module/components/subdomain/admin/_AdminAzureDevopsSearchForm.module.scss';

const Errors = {
  'not authorized': `You are not authorized to use this feature. Reach for one of you company's admins for support.`,
  'integration not installed': `Your company does not have the Azure DevOps integration installed. Please, install it before linking work items.`,
};

const AdminAzureDevopsSearchForm = ({ workItemSuggestions, loadSuggestions, post, reloadPost }) => {
  // state
  const [error, setError] = useState(null);

  // helpers
  const linkWorkItem = async (workItem) => {
    setError(null);

    const response = await AJAX.post('/api/azureDevops/workItems/link', {
      postID: post._id,
      projectID: workItem.projectId,
      workItemID: workItem.id,
    });

    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
      errors: Errors,
    });
    if (error) {
      setError(error.message);
      return;
    }

    await reloadPost(post);
  };

  // renders
  const renderError = () => (error ? <div className="error">{error}</div> : null);
  const renderSuggestion = (suggestion) => suggestion?.title;

  return (
    <div className={styles.adminAzureDevopsSearchForm}>
      <AdminIntegrationSearchForm
        autoFocus={true}
        loadSuggestions={loadSuggestions}
        onSuggestionSelected={linkWorkItem}
        placeholder="Work Item title"
        renderSuggestion={renderSuggestion}
        suggestions={workItemSuggestions}
      />
      {renderError()}
    </div>
  );
};

AdminAzureDevopsSearchForm.propTypes = {
  workItemSuggestions: PropTypes.object,
  post: PropTypes.object,
};

export default connect(
  (state) => ({ workItemSuggestions: state.azureDevopsWorkItemSuggestions }),
  (dispatch) => ({
    loadSuggestions: (searchQuery) => dispatch(loadSuggestions(searchQuery)),
    reloadPost: (post) => {
      return Promise.all([dispatch(invalidateSuggestions()), dispatch(reloadPost(post))]);
    },
  }),
)(AdminAzureDevopsSearchForm);
